import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth, AuthUser } from '../contexts/AuthContext';
import { isAtLeast } from '../utils/roles';

interface RoleRouteProps {
  children: React.ReactNode;
  roles: AuthUser['role'][];
}

export function RoleRoute({ children, roles }: RoleRouteProps) {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Forced first-login password change removed — no redirect to /change-password.

  // Use hierarchy: if user's role is at or above any of the required roles, allow access
  const hasAccess = user && roles.some(requiredRole => isAtLeast(user.role, requiredRole));

  if (!hasAccess) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to access this resource.</p>
        <button
          onClick={() => navigate(-1)}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1.2rem',
            fontSize: '0.85rem',
            fontWeight: 600,
            backgroundColor: '#1a6b3c',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          ← Go Back
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
